import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import HiddenLayout from './HiddenLayout';
const MatureAnonymousBlockedOverlay = (props)=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
        icon: /*#__PURE__*/ React.createElement(HiddenIcon, {
            size: IconSize.HUGE
        }),
        text: t('deviationview.blocked.mature.text'),
        button: /*#__PURE__*/ React.createElement(GhostButton, {
            variant: "main",
            size: "medium",
            href: Url.joinLink('mature'),
            biData: {
                evid: BiEventType.REDIRECT_TO_LOGIN,
                referral_info: ReferralType.NSFG
            }
        }, t('deviationview.blocked.nsfg.anon.signIn'))
    }, props));
};
MatureAnonymousBlockedOverlay.displayName = 'MatureAnonymousBlockedOverlay';
export default MatureAnonymousBlockedOverlay;
